import {
    getVueInstance as vue,
} from '@shared/utils/instance';

import {
    Validation,
} from '@shared/validations';

// Just for WEB, not supported by NS
export const noEmojisAllowedForWeb: Validation = (text: string) => (!(/\p{Emoji_Presentation}/ug).test(text)) ||
    vue().$t('errors.invalidCharacters');